import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Button } from "./ButtonNew";
import { CustomModal } from "./CustomModal";

type DeleteConfirmModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
};

export const DeleteConfirmModal = ({ onCancel, onConfirm, open }: DeleteConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      className="max-h-[90rem] overflow-scroll"
      height="25rem"
      modalOpen={open}
      setModalOpen={(isOpen: boolean) => {
        if (!isOpen) onCancel();
      }}
      width="40rem"
    >
      <Stack className="font-ds-headline-md h-full w-full flex-col justify-between p-4">
        <h3>{t("general.deleteConfirmMessage")}</h3>
        <Stack className="gap-4">
          <Button
            className="w-20"
            onClick={(event) => {
              event.stopPropagation();
              onConfirm();
            }}
            size="md"
            variant="error"
          >
            {t("general.yes")}
          </Button>
          <Button
            className="w-20"
            onClick={(event) => {
              event.stopPropagation();
              onCancel();
            }}
            size="md"
            variant="secondary"
          >
            {t("general.cancel")}
          </Button>
        </Stack>
      </Stack>
    </CustomModal>
  );
};
